
import ROUTERS from '../../commons/constans/router';
import React, { lazy } from 'react';


const FaqComponent = lazy(() => import('../../pages/Faq/containers/FaqPageContainer'));


const route = [
  {
    path: ROUTERS.FAQ,
    title: 'Faq List',
    exact: true,
    public: false,
    component: <FaqComponent />,
  },
];

export default route;